import './table.scss';
import OrderModel from '../../../../../base/models/appointmentManagement/dashboard/dashboardModel';
import { Empty } from 'antd';
import { getResourceTypeText, getCheckTimeText, getTimeRangeText } from './tableUtils';
import Loading from './Loading';

interface AllTablePcProps {
    dataList: OrderModel[];
    getModelInfo: (item: OrderModel) => void;
    appointType: number | string;
    loading?: boolean;
}

const AllTablePc = ({ dataList, getModelInfo, appointType, loading = false }: AllTablePcProps) => {
    return (
        <div className="vault-main table-main">
            <div className="table">
                <div className="table-header">
                    <div className="tr">
                        <div className="td">Arrival Date</div>
                        <div className="td">Name</div>
                        <div className="td">Booking Code</div>
                        <div className="td">Time</div>
                        <div className="td">Phone Number</div>
                        <div className="td visitor-field-hidden">Visitor</div>
                        <div className="td">Booking Type</div>
                        {appointType !== 3 && <div className="td">Check Time</div>}
                        <div className="td">Status</div>
                    </div>
                </div>
                <div className="table-body">
                    {loading ? <Loading /> : <>
                        {dataList.map((item: OrderModel, index: number) => (
                            <div className="tr" key={item.id || index}>
                                <div className="td">{item.booking_date || '-'}</div>
                                <div className="td">{item.appointment_name || '-'}</div>
                                <div className="td">{item.appointment_code || '-'}</div>
                                <div className="td">{getTimeRangeText(item)}</div>
                                <div className="td">{item.contact_mobile || '-'}</div>
                                <div className="td visitor-field-hidden">{item.visitor_count || '-'}</div>
                                <div className="td">{getResourceTypeText(item.resource_type)}</div>
                                {appointType !== 3 && <div className="td">{getCheckTimeText(item)}</div>}
                                {
                                    item.status === 5 && (
                                        <div className="td">
                                            <div className="completed-text">Completed</div>
                                        </div>
                                    )
                                }
                                {
                                    item.status === 3 && (
                                        <div className="td">
                                            <div className="completed-text">Cancelled</div>
                                        </div>
                                    )
                                }
                                {
                                    (item.status === 1 || item.status === 4) && (
                                        <div className="td">
                                            <div
                                                className="btn"
                                                onClick={() => getModelInfo(item)}
                                            >
                                                Check In
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    item.status === 2 && (
                                        <div className="td">
                                            <div
                                                className="btn"
                                                onClick={() => getModelInfo(item)}
                                            >
                                                Check Out
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        ))}
                        {dataList.length === 0 && <div className="no-data"><Empty /></div>}
                    </>}
                </div>
            </div>
        </div>
    );
};

export default AllTablePc;
